import { type FC, useCallback, useMemo } from 'react';

import { AccommodationStickyOffer } from '@vakantiesnl/components/src/molecules/AccommodationStickyOffer';
import { useAccoAvailabilityCheck } from '@vakantiesnl/components/src/utils/accommodation/useAccoAvailabilityCheck';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { useGetAccommodationByEntityId } from '@vakantiesnl/services/src/hooks/queries';
import { useGetFinalOffer } from '@vakantiesnl/services/src/stores';

type Props = {
	isPriceInView?: boolean;
	/** If the offers are still need to be fetched; to prevent price flashing */
	isLoadingOffers?: boolean;
};

export const StickyOfferWrapper: FC<Props> = ({ isPriceInView, isLoadingOffers }) => {
	const { isDesktop } = useBreakpoints();
	const microCopies = useMicroCopyContext();
	const { accommodation } = useGetAccommodationByEntityId();
	const currentOffer = useGetFinalOffer(accommodation);

	const label = useMemo(() => (isDesktop ? 'offer_drawer_header' : 'offer_drawer_footer'), [isDesktop]);

	const trackCTAClick = useCallback(() => {
		import('@vakantiesnl/services/src/gtm/common').then(({ track }) => {
			import('@vakantiesnl/services/src/gtm/accommodationPage').then(({ bookNowStickyOfferSummary }) =>
				track(bookNowStickyOfferSummary(accommodation, label)),
			);
		});
	}, [accommodation, label]);

	const { checkAvailability } = useAccoAvailabilityCheck({ onClick: trackCTAClick, gtmLabel: label });

	if (!currentOffer) return null;
	else
		return (
			<AccommodationStickyOffer
				selectedOffer={currentOffer}
				microCopies={microCopies}
				onClick={checkAvailability}
				accommodation={accommodation}
				isPriceInView={isPriceInView}
				isLoadingOffers={isLoadingOffers}
			/>
		);
};
